import { useEffect, useState } from "react";
import { useFormik } from "formik";
import RenderToast from "@/components/RenderToast";
import UserContactSupportSchema from "@/schema/CommunicationMGMT/ContactSupport/user-schema";
import useFormApiState from "@/CustomHooks/useFormApiState";
import UserContactSupportValues from "@/data/CommunicationMGMT/ContactSupport/user-intial-values";
import { usePost } from "@/apiHooks/HttpFunctions";
import AsyncDropdown from "../AsyncDropdown/AsyncDropdown";
import { Loader } from "../Loader";
import { CONTACT_SUPPORT_TYPE } from "@/constant/ContactSupport/status";

const AssignedToDropdown = ({ api, data, userOptions, showIsFetching }) => {
  const handleSuccess = () => (data) => {
    RenderToast({
      type: "success",
      message: `The Ticket has been assigned successfully.`,
    });
  };

  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    if (!!data.id && !hasOpened) {
      setHasOpened(true);
    }
  }, [data.id, hasOpened]);

  const {
    mutate: saveEdit,
    isPending: saveEditIsPending,
    error: saveEditError,
  } = usePost({
    apiURL: `${api}/${data.id}/assigned-to`,
    isFormData: true,
    onSuccess: handleSuccess(),
  });

  const { saveError } = useFormApiState([saveEditIsPending], [saveEditError]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: UserContactSupportValues(data),
    validationSchema: UserContactSupportSchema(),
  });

  const handleSubmitAssignedTo = (values) => {
    const formData = new FormData();
    formData.append("assigned_to_id", values.assigned_to_id);
    saveEdit(formData);
  };

  if (showIsFetching) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Loader />
      </div>
    );
  }

  const user =
    userOptions?.data.find(
      (option) => option.id === formik.values.assigned_to_id
    ) || null;

  return (
    <div
      className="flex justify-start gap-2 width[50px] relative cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <AsyncDropdown
        required={false}
        isDisabled={
          saveEditIsPending ||
          data?.status?.type === CONTACT_SUPPORT_TYPE.CLOSED
        }
        fontSize={"14px"}
        placeholder="Unassigned"
        height={24}
        containerClassName="!grid-cols-5 w-[220px] !gap-0"
        dropdownWrapperClassName="!col-span-5 !ml-0"
        defaultOptions={userOptions?.data.map((option) => ({
          label: option.first_name,
          value: option.id,
        }))}
        isLoading={showIsFetching}
        value={{
          value: user?.id,
          label: user?.first_name || "Unassigned",
        }}
        onChange={(selected) => {
          formik.setFieldValue("assigned_to_id", selected?.value || null);
          handleSubmitAssignedTo({
            assigned_to_id: selected?.value || null,
          });
        }}
        errorText={
          (formik.touched.type && formik.errors.type) ||
          (saveError?.status === 422 &&
            saveError?.response?.data?.errors?.type?.join(" "))
        }
      />
    </div>
  );
};

export default AssignedToDropdown;
